// Re-export from the new supabase-native shim.
export { trpcClient } from '@web/utils/api/trpcClient';
